import React from 'react';
import CommonBlog from './CommonBlog';

const BlogTwo = () => {
    return (
        <CommonBlog items={false} count={4} />
    );
};

export default BlogTwo;